<template>
  <div class="maincontentWrapper">
      <dwgwzmd
        v-for="(item, index) in contentList"
        :floatSet="getClassSet(index)"
        :List="item"
        :key="item.tltle"
      ></dwgwzmd>
  </div>
</template>

<script>
// 引入动画
import dwgwzmd from "@/components/dwgwzmd";

export default {
  name: "dwgwsy",
  components: {
    dwgwzmd,
  },
  data() {
    return {
      contentList: [
        {
          title: "对冲量化基金",
          content:
            "秉承道德和诚信原则，借助科学与专业的力量，尝试对学术和实践领域做突破性创新研究， 立志推动中国量化基金发展。",
          jpgList: [
            require("./jpg/index1_1.jpg"),
            require("./jpg/index1_2.jpg"),
          ],
        },
        {
          title: "有生命力的团队",
          content:
            "我们欣赏专业领域的好奇心以及解决问题的执着较真。我们为才华横溢的头脑提供一流的平台， 我们相信，会拼会玩会生活有温度的团队，将会成为无可比拟的财富。",
          jpgList: [
            require("./jpg/index1_2.jpg"),
            require("./jpg/index1_3.jpg"),
          ],
        },
        {
          title: "实力缔造卓越",
          content:
            "以强大的投研及管理能力， 应对不断变化的挑战和机遇，始终把投资者利益放在首位，成为可靠出色的财富管理人。",
          jpgList: [
            require("./jpg/index_carousel3_1.jpg"),
            require("./jpg/index_carousel3_2.jpg"),
          ],
        },
      ],
    };
  },
  methods: {
    getClassSet(index) {
      return index % 2 == 0 ? "rightSet" : "leftSet";
    },
  },
};
</script>

<style scoped>
.maincontentWrapper {
  margin: auto;
  margin-top: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwsy.vue